import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// import Layout from "./components/layout";
import Views from "./views";
import { publicRoutes } from "../src/configs/routes.config";

import "./App.css";
import Header from "./components/template/header";
import Footer from "./components/template/footer";
import ScrollToTop from "./components/shared/ScrollToTop";

function App() {
  const countApi = useRef(0);

  const location = useLocation();
  const [header, setHeader] = useState(false);
  const [footer, setFooter] = useState(false);

  const normalizePath = (path) => {
    if (!path) return path;
    if (path === "/") return path;
    return path.replace(/\/+$/, "");
  };

  useEffect(() => {
    if (!countApi.current) {
      countApi.current = countApi.current + 1;
    }
  }, [])

  useEffect(() => {
    const allRoutes = [...publicRoutes]
    const currentRoute = allRoutes?.find((route) => {
      const routePath = normalizePath(route.path.replace(/:slug/, '[^/]+'));
      const currentPath = normalizePath(location.pathname);
      const regex = new RegExp(`^${routePath}$`);
      return regex.test(currentPath);
    })
    if (currentRoute) {
      setHeader(currentRoute.header);
      setFooter(currentRoute.footer);
    } else {
      setHeader(false);
      setFooter(false);
    }
  }, [location.pathname]);

  return (
    <>
      {header && <Header/>}
      <Views />
      {footer && <Footer/>}
      <ScrollToTop />
    </>
  );
}

export default App;
